import { Component } from '@mycolorway/tao';
import flatpickr from 'next/javascripts/modules/flatpickr';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

function padStart(originalStr, targetLength, padStr) {
  const result = [...Array(targetLength)].map(() => padStr).join('') + originalStr;
  return result.slice(result.length - targetLength);
}

Component('tr-date-time-field', {
  mixins: [eventListenerMixin],

  properties: {
    minuteStep: {
      type: Number,
      default: 15,
    },

    valueFormat: {
      type: String,
      default: 'Y-m-dTH:i:S',
    },
  },

  connected() {
    this.nativeField = this.querySelector('.mdc-form-field > input.native-field');
    this.dateField = this.querySelector('tr-date-field');
    this.timeField = this.querySelector('tr-combo-select-field');

    this.listenTo(this.dateField, 'tr-date-field:change', this.handleDateChange.bind(this));
    this.listenTo(this.timeField, 'tr-combo-select-field:change', this.handleTimeChange.bind(this));
  },

  ready() {
    this.initDefaultValue();
  },

  disconnected() {
    this.stopListening();
  },

  initDefaultValue() {
    let datetime = new Date();
    const { value } = this.nativeField;
    if (value) datetime = flatpickr.parseDate(value, this.valueFormat);

    const date = flatpickr.formatDate(datetime, 'Y-m-d');
    const hour = datetime.getHours();
    const minute = datetime.getMinutes();
    const minutes = [...Array(59).keys()];

    let selectedMinute;
    while (minutes.length > 0) {
      const items = minutes.splice(0, 15);
      if (items.indexOf(minute) !== -1) {
        selectedMinute = Math.min.apply(null, items);
        break;
      }
    }

    const time = `${padStart(hour, 2, '0')}:${padStart(selectedMinute, 2, '0')}`;
    this.dateField.setValue(date);
    this.timeField.setValue(time);
    this.setNativeFieldValue({ date, time });
  },

  value() {
    return this.nativeField.value;
  },

  handleDateChange(event) {
    this.setNativeFieldValue({ date: event.detail, time: this.timeField.getValue() });
    this.notifyChange();
  },

  handleTimeChange(event) {
    this.setNativeFieldValue({ date: this.dateField.getValue(), time: event.detail });
    this.notifyChange();
  },

  setNativeFieldValue({ date, time }) {
    if (date) {
      const datetime = flatpickr.parseDate(`${date} ${time}`, 'Y-m-d H:i');
      this.nativeField.value = flatpickr.formatDate(datetime, this.valueFormat);
    } else {
      this.nativeField.value = '';
    }
  },

  notifyChange() {
    this.namespacedTrigger('change', {
      detail: this.nativeField.value, bubbles: true,
    });
  },
});
